"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceTemplateString = replaceTemplateString;
exports.defineFegoVariable = defineFegoVariable;
exports.hasDefineFegoVariable = hasDefineFegoVariable;
/** 将模板中的 {key} 替换为对象对应值，未匹配则保留占位符 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function replaceTemplateString(template, obj) {
    return template.replace(/\{(\w+)\}/g, (match, key) => {
        return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : match;
    });
}
/**
 * 定义fego变量
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function defineFegoVariable(key, value) {
    const editor = require('@futuweb/fego-editor');
    editor.app.project.setVariable(Object.assign(editor.app.project.variable, {
        [key]: value
    }));
}
/**
 * 判断fego变量是否定义
 */
function hasDefineFegoVariable(key) {
    const editor = require('@futuweb/fego-editor');
    return editor.app.project.variable[key] !== undefined;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLHNEQUlDO0FBTUQsZ0RBT0M7QUFLRCxzREFHQztBQTNCRCxxQ0FBcUM7QUFDckMsOERBQThEO0FBQzlELFNBQWdCLHFCQUFxQixDQUFDLFFBQWdCLEVBQUUsR0FBd0I7SUFDNUUsT0FBTyxRQUFRLENBQUMsT0FBTyxDQUFDLFlBQVksRUFBRSxDQUFDLEtBQUssRUFBRSxHQUFHLEVBQUUsRUFBRTtRQUNqRCxPQUFPLE1BQU0sQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDO0lBQzdFLENBQUMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQztBQUVEOztHQUVHO0FBQ0gsOERBQThEO0FBQzlELFNBQWdCLGtCQUFrQixDQUFDLEdBQVcsRUFBRSxLQUFVO0lBQ3RELE1BQU0sTUFBTSxHQUFHLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO0lBQy9DLE1BQU0sQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FDMUIsTUFBTSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxRQUFRLEVBQUU7UUFDdkMsQ0FBQyxHQUFHLENBQUMsRUFBRSxLQUFLO0tBQ2YsQ0FBQyxDQUNMLENBQUM7QUFDTixDQUFDO0FBRUQ7O0dBRUc7QUFDSCxTQUFnQixxQkFBcUIsQ0FBQyxHQUFXO0lBQzdDLE1BQU0sTUFBTSxHQUFHLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO0lBQy9DLE9BQU8sTUFBTSxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxLQUFLLFNBQVMsQ0FBQztBQUMxRCxDQUFDIn0=